import React from "react";
import {
  Button,
  Col,
  Modal,
  Row,
  ListGroup,
  ProgressBar,
  Form,
  ListGroupItem,
} from "react-bootstrap";
const Case5 = ({
  isOnlyFrame,
  handleBack4,
  Specification,
  product,
  setSpecification,
  selectedLens,
  addToCartHandler,
}) => {
  return (
    <>
      <Col className='shadow' md={8}>
        <ProgressBar
          className=' Fpro shadow'
          variant='info'
          animated
          now={100}
        />
        <Modal.Header closeButton>
          {isOnlyFrame ? (
            ""
          ) : (
            <Button
              onClick={handleBack4}
              size='sm'
              className='btn-light Psbutton shadow'
            >
              <i className='fa fa-arrow-left' aria-hidden='true'></i>
            </Button>
          )}
        </Modal.Header>
        <Modal.Title className='text-center'>Check and Purchase</Modal.Title>
        <Modal.Body>
          <ListGroup variant='flush'>
            {/* <ListGroupItem>
        <Row>
          <Col>Frame:</Col>
          <Col>{Specification.frame}</Col>
        </Row>
      </ListGroupItem> */}

            <ListGroupItem>
              <Row>
                <Col>Prescription:</Col>
                <Col>
                  {isOnlyFrame
                    ? "Frame Only includes Stock 0 power lenses"
                    : Specification.prescriptionType}
                </Col>
              </Row>
            </ListGroupItem>

            <ListGroup.Item>
              <Row>
                <Col>Status:</Col>
                <Col>
                  {product.countInStock > 0 ? "In Stock" : "Out Of Stock"}
                </Col>
              </Row>
            </ListGroup.Item>
            {product.countInStock > 0 && (
              <ListGroup.Item>
                <Row>
                  <Col>Qty</Col>
                  <Col>
                    <Form.Control
                      size='sm'
                      as='select'
                      value={Specification.qty}
                      onChange={(e) =>
                        setSpecification({
                          ...Specification,
                          qty: e.target.value,
                        })
                      }
                    >
                      {[...Array(product.countInStock).keys()].map((x) => (
                        <option key={x + 1} value={x + 1}>
                          {x + 1}
                        </option>
                      ))}
                    </Form.Control>
                  </Col>
                </Row>
              </ListGroup.Item>
            )}
            <ListGroupItem>
              <Row>
                <Col> Frame Price:</Col>

                <Col>${product.price}</Col>
              </Row>
            </ListGroupItem>
            {!isOnlyFrame && (
              <ListGroupItem>
                <Row>
                  <Col> Lens Name:</Col>

                  <Col>{selectedLens.name}</Col>
                </Row>
                <Row>
                  <Col> Lens Price:</Col>

                  <Col>${selectedLens.price}</Col>
                </Row>
              </ListGroupItem>
            )}

            <ListGroup.Item>
              <Button
                onClick={addToCartHandler}
                className='Psbutton btn-light rounded shadow'
                type='button'
                disabled={product.countInStock === 0}
              >
                Add To Cart
              </Button>
            </ListGroup.Item>
          </ListGroup>
        </Modal.Body>
      </Col>
    </>
  );
};

export default Case5;
